// Горната лента на листа „Прехвърляне" (`WorksheetTopBand`, по модела на
// доставката): назад · заглавие и реквизитите на един ред — От склад → Към
// склад · Дата · Бележка. Стрелката между двата склада е част от дизайна —
// прехвърлянето винаги е посока, не просто два избора.
import type { ComponentProps } from "react";
import { DatePicker, Input, Select } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import type { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import type { Warehouse } from "../../../../api/inventory";
import { useInventoryShell } from "../../components/shell/InventoryShellContext";
import { WorksheetField, WorksheetTopBand } from "../../components/worksheet/WorksheetTopBand";

type Props = {
  // назад · заглавие
  band: Omit<ComponentProps<typeof WorksheetTopBand>, "children">;
  date: Dayjs | null;
  onDateChange: (value: Dayjs | null) => void;
  fromWarehouseId: number | null;
  onFromWarehouseChange: (value: number) => void;
  toWarehouseId: number | null;
  onToWarehouseChange: (value: number) => void;
  warehouses: Warehouse[];
  sameWarehouseError: boolean;
  note: string;
  onNoteChange: (value: string) => void;
};

export const TransferWorksheetHeader = ({
  band,
  date,
  onDateChange,
  fromWarehouseId,
  onFromWarehouseChange,
  toWarehouseId,
  onToWarehouseChange,
  warehouses,
  sameWarehouseError,
  note,
  onNoteChange,
}: Props) => {
  const { t } = useTranslation();
  const { isNarrow } = useInventoryShell();
  const warehouseOptions = warehouses.map((warehouse) => ({
    value: warehouse.id,
    label: warehouse.name,
  }));

  return (
    <WorksheetTopBand {...band}>
      <WorksheetField label={t("inventoryPage.fieldFromWarehouse")} required>
        <Select
          value={fromWarehouseId ?? undefined}
          onChange={(value) => onFromWarehouseChange(value as number)}
          options={warehouseOptions}
          placeholder={t("inventoryPage.fieldFromWarehousePh")}
          status={sameWarehouseError ? "error" : undefined}
          className="w-full"
        />
      </WorksheetField>
      {!isNarrow && <ArrowRightOutlined className="mb-3 shrink-0 text-[15px] text-brand-deep-ink" />}
      <WorksheetField label={t("inventoryPage.fieldToWarehouse")} required>
        <Select
          value={toWarehouseId ?? undefined}
          onChange={(value) => onToWarehouseChange(value as number)}
          options={warehouseOptions}
          placeholder={t("inventoryPage.fieldToWarehousePh")}
          status={sameWarehouseError ? "error" : undefined}
          className="w-full"
        />
      </WorksheetField>
      <WorksheetField label={t("inventoryPage.colDate")} required size="sm">
        <DatePicker
          value={date}
          onChange={onDateChange}
          format="DD.MM.YYYY"
          allowClear={false}
          className="w-full"
        />
      </WorksheetField>
      <WorksheetField label={t("inventoryPage.fieldNote")} size="grow">
        <Input
          value={note}
          onChange={(event) => onNoteChange(event.target.value)}
          placeholder={t("inventoryPage.trxNotePh")}
          className="w-full"
        />
      </WorksheetField>
    </WorksheetTopBand>
  );
};

export default TransferWorksheetHeader;
